<template>
<div>
  <p>Согласие ПДН <a :href="Url" target="_blank">Открыть документ</a></p>
</div>
</template>

<script>
export default {
  /*
  нужна процедура которая по токену из GUIDeasyConf получит данные и подставит в форму аналогичную @/views/pdlloan/docPDN_IL'
   */

  name: "instCheckBox_AGREEMENT_PDN",
  data(){
    return{
      Url: 'https://lk.msk.finmoll.com/public/pdnIl/'+ localStorage.getItem('GUIDeasyConf')
    }
  },
}
</script>

<style scoped>

</style>